import React, { ComponentType } from 'react';
import { classes, Root } from './withRequired.styles';




// eslint-disable-next-line react/display-name
const withRequired = (WrappedComponent: ComponentType<any>) =>
  function (props: any) {
    return (
      <Root className={classes.root}>
        <div className={classes.value}>
          <WrappedComponent {...props} />
        </div>
      </Root>
    );
  };

export default withRequired;
